import React, { useEffect, useState } from "react";
import { ProductSelector } from "../imports";

export default function CustomDimensionsForm({
  setCanWidth,
  setCanHeight,
  setSelectedProduct,
  selectedProduct,
}) {
  const [width, setWidth] = useState("");
  const [height, setHeight] = useState("");
  const [product, setProduct] = useState({});
  const price = product.variants && product.variants[0].price;
  const compareAtPrice =
    product.variants && product.variants[0].compare_at_price;

  useEffect(() => {
    if (height && width) {
      let handle = `${height}x${width}-canvas-photo-print`;
      setCanWidth(width);
      setCanHeight(height);
      ProductSelector.loadProduct(
        handle,
        (product) => {
          setProduct(product);
          setSelectedProduct(product);
        },
        false
      );
    }
  }, [width, height]);

  const onChange = (e) => {
    if (e.target.name === "height") {
      setHeight(e.target.value);
    } else {
      setWidth(e.target.value);
    }
  };
  const isSelected = product.id && selectedProduct.id === product.id;
  return (
    <div
      id="threekit-custom-dimension"
      className={isSelected ? "selected" : ""}
    >
      <h5>Custom Size</h5>
      <div className="size-option">
        <form id="threekit-dimensions-form">
          <input
            type="number"
            id="threekit-height"
            name="height"
            min="8"
            max="60"
            placeholder='H"'
            value={height}
            onChange={onChange}
          />
          <div className="x_symbol">x</div>
          <input
            type="number"
            id="threekit-width"
            name="width"
            min="8"
            max="60"
            placeholder='W"'
            value={width}
            onChange={onChange}
          />
        </form>
        <span className="price">{price}</span>
        <span className="compare-at-price">{compareAtPrice}</span>
      </div>
    </div>
  );
}
